// extracted by mini-css-extract-plugin
module.exports = {"root":"IconShare_root__X7Oew"};